import { useSelector } from 'react-redux';
import { ImageList, ImageListItem } from '@mui/material';

import isEmpty from 'Lib/utilities/isEmpty';

const DocumentImages = ({ files }) => {
    const domain = useSelector(state => state.app.domain);
    const account = useSelector(state => state.app.account);

    const fileLocations = file => {
        const path = `/api/manager/files/${file.fileID}/preview`;
        const thumbnail = `/api/manager/files/${file.fileID}/thumbnail`;
        const source = `https://${account.subdomain}${domain}` + (isEmpty(file.previewFileName) && file.isImage ? path : thumbnail);

        return [path, source];
    };

    return (
        <ImageList cols={2} rowHeight={164}>
            {files.map((file, index) => {
                const [filePath, fileSource] = fileLocations(file);

                return (
                    <ImageListItem key={index} style={{ cursor: 'pointer', margin: '16px 0' }}>
                        <img src={fileSource} onClick={() => window.open(filePath, '_blank')} style={{ objectFit: 'cover', maxHeight: '164px' }} />
                    </ImageListItem>
                );
            })}
        </ImageList>
    );
};

export default DocumentImages;
